import React from "react";
import DadosBasicosCompradorLibraFormConnected from "./comprador/DadosBasicosCompradorLibraForm.connected";
import HubLibraConnected from "./HubLibra.connected";
import DadosEnderecoImovelLibraFormConnected from "./imovel/DadosEnderecoImovelLibraForm.connected";
import OutrasInformacoesImovelLibraFormConnected from "./imovel/OutrasInformacoesImovelLibraForm.connected";
import DadosProfissionaisLibraFormConnected from "./comprador/DadosProfissionaisLibraForm.connected";
import DadosEstadoCivilLibraFormConnected from "./comprador/DadosEstadoCivilLibraForm.connected";
import ReenquadrarOperacaoFormConnected from "../ReenquadrarOperacaoForm.connected";
import ConfirmarNovoCalculoConnected from "../ConfirmarNovoCalculo.connected";

const FluxoLibra = (props) => {
  return (
    <>
      {props.step === 0 && <HubLibraConnected {...props} />}
      {props.step === 1 && (
        <DadosBasicosCompradorLibraFormConnected {...props} />
      )}
      {props.step === 2 && <DadosProfissionaisLibraFormConnected {...props} />}
      {props.step === 3 && <DadosEstadoCivilLibraFormConnected {...props} />}

      {props.step === 100 && (
        <DadosEnderecoImovelLibraFormConnected {...props} />
      )}
      {props.step === 101 && (
        <OutrasInformacoesImovelLibraFormConnected {...props} />
      )}
      {props.step === 995 && <ReenquadrarOperacaoFormConnected {...props} />}
      {props.step === 996 && <ConfirmarNovoCalculoConnected {...props} />}
    </>
  );
};

export default FluxoLibra;
